
import Index from '~/pages/new/landing/_landing/index'
export default Index
